/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod';
import { languageSchema } from './language-schema';

export const candidateLanguageSchema: z.AnyZodObject = z.object({
  candidateId: z.string().uuid().nullish(),
  createdAt: z.string().datetime().nullish(),
  id: z.string().uuid(),
  language: z.lazy(() => languageSchema).nullish(),
  languageCEFR: z.string().nullish(),
  languageId: z.string().uuid().nullish(),
  languageProficiency: z.string().nullish(),
  languageSkill: z.string().nullish(),
  updatedAt: z.string().datetime().nullish(),
});

export type CandidateLanguage = z.infer<typeof candidateLanguageSchema>;
